const services = {
  header: {
    create: 'Erstellen',
  },
  toast: {
    error: {
      badResponse: '[Service] Ungültige Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {
        body: 'Der Dienst wurde erfolgreich hinzugefügt',
      },
      delete: {
        body: 'Dienste wurden erfolgreich gelöscht',
      },
      edit: {},
    },
  },
  headerButtons: {
    create: 'Neu',
    delete: 'Löschen',
  },
  table: {
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    headers: {
      maxPassengers: 'Max. Passagiere',
      sharedWith: 'Geteilt mit',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  create: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Dienst konnte nicht erstellt werden',
    },
    successToast: {
      message: 'Erfolg! Dienst erfolgreich erstellt',
    },
  },

  edit: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Der Dienst konnte nicht aktualisiert werden.',
    },
    successToast: {
      message: 'Erfolg! Dienst erfolgreich aktualisiert',
    },
  },

  delete: {
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Der Dienst konnte nicht gelöscht werden.',
    },
    successToast: {
      message: 'Erfolg! Der Dienst wurde erfolgreich gelöscht',
    },
  },

  forms: {
    header: {
      createService: {
        title: 'Erstellen',
      },

      updateService: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Name',
          type: 'Typ',
          maxPassengers: 'Max. Passagiere',
          shared: 'Geteilt mit',
          availableCount: 'Anzahl der Fahrzeuge',
          penaltyScore: {
            title: 'Strafpunktzahl',
            description: 'measured in minutes.,Kosten für die Fahrzeugmiete im Vergleich zur zusätzlichen Streckendauer, gemessen in Minuten., measured in minutes.',
          }
        },
      },
      actions: {
        header: 'Aktionen',
        buttons: {
          delete: 'Löschen',
          resetPassword: 'Passwort zurücksetzen',
        },
      },
    },
  },

  serviceTypes: {
    private: 'Privat',
    shared: 'Geteilt',
  },

  deleteModal: {
    header: 'Dienste löschen',
    body: 'Sie sind dabei, {{num}} Dienste zu löschen.',
  },
};

export default services;
